import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "block text-sm font-medium text-gray-700 mb-2" }
const _hoisted_2 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_3 = { class: "space-y-2 max-h-[190px] overflow-y-auto border border-gray-300 rounded-lg p-3" }
const _hoisted_4 = ["value", "checked", "onChange"]
const _hoisted_5 = { class: "ml-2 text-sm text-gray-700" }
const _hoisted_6 = {
  key: 0,
  class: "text-sm text-blue-600 mt-2"
}

import { computed } from 'vue';
import type { ProductCategoriesFieldProps } from '@/types/sellerRegister';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductCategoriesField',
  props: {
    label: {},
    required: { type: Boolean, default: false },
    modelValue: {},
    gridClass: { default: '' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Catégories disponibles
const categories: Array<{ value: string; label: string }> = [
  { value: 'femmes', label: 'Femmes' },
  { value: 'femmes-grande-taille', label: 'Femmes Grande Taille' },
  { value: 'hommes', label: 'Hommes' },
  { value: 'enfants', label: 'Enfants' },
  { value: 'chaussures-femmes', label: 'Chaussures femmes' },
  { value: 'chaussures-hommes', label: 'Chaussures hommes' },
  { value: 'chaussures-enfants', label: 'Chaussures enfants' },
  { value: 'maroquinerie', label: 'Maroquinerie' },
  { value: 'accessoires', label: 'Accessoires' }
];

const selectedCount = computed(() => props.modelValue.length);

const isSelected = (value: string) => {
  return props.modelValue.includes(value);
};

const toggleCategory = (value: string) => {
  const newSelection = [...props.modelValue];
  if (isSelected(value)) {
    // Retirer la catégorie
    const index = newSelection.indexOf(value);
    newSelection.splice(index, 1);
  } else {
    // Ajouter la catégorie
    newSelection.push(value);
  }
  emit('update:modelValue', newSelection);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.gridClass)
  }, [
    _createElementVNode("label", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      (_ctx.required)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(categories, (category) => {
        return _createElementVNode("label", {
          key: category.value,
          class: "flex items-center hover:bg-gray-50 rounded transition-colors"
        }, [
          _createElementVNode("input", {
            value: category.value,
            type: "checkbox",
            checked: isSelected(category.value),
            onChange: ($event: any) => (toggleCategory(category.value)),
            class: "h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
          }, null, 40, _hoisted_4),
          _createElementVNode("span", _hoisted_5, _toDisplayString(category.label), 1)
        ])
      }), 64))
    ]),
    (selectedCount.value > 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(selectedCount.value) + " catégorie(s) sélectionnée(s) ", 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})